/**
 * Get and validate the user API endpoint from environment variables
 * @returns {string} The validated API endpoint URL
 * @throws {Error} If VITE_USER_ENDPOINT is not defined
 */
export const getUserEndpoint = () => {
  const endpoint = import.meta.env.VITE_USER_ENDPOINT;

  if (!endpoint) {
    const errorMessage =
      'VITE_USER_ENDPOINT environment variable is required. ' +
      'Please configure it in Cloudflare Pages → Settings → Environment Variables → Build.';
    
    console.error('[API] ❌', errorMessage);
    console.error('[API] Current environment:', {
      MODE: import.meta.env.MODE,
      VITE_USER_ENDPOINT: import.meta.env.VITE_USER_ENDPOINT ? '[set]' : '[missing]',
    });
    
    throw new Error(errorMessage);
  }

  // Remove trailing slash if present to avoid double slashes in URL construction
  const normalizedEndpoint = endpoint.replace(/\/+$/, '');
  
  return normalizedEndpoint;
};
